const hydratedGalleries = new WeakSet<HTMLElement>()

export function hydrateGalleryStripes(
  container: Document | Element = document
): void {
  const galleries = container.querySelectorAll<HTMLElement>(
    '.vssl-stripe--gallery'
  )

  galleries.forEach((galleryEl) => {
    if (hydratedGalleries.has(galleryEl)) return
    hydratedGalleries.add(galleryEl)

    const nextBtn = galleryEl.querySelector<HTMLButtonElement>(
      '.vssl-stripe--gallery--next'
    )
    const prevBtn = galleryEl.querySelector<HTMLButtonElement>(
      '.vssl-stripe--gallery--prev'
    )
    const currentCounter = galleryEl.querySelector<HTMLElement>(
      '.vssl-stripe--gallery--current'
    )
    const slideEls = galleryEl.querySelectorAll<HTMLElement>(
      '.vssl-stripe--gallery--slide'
    )
    const controls = galleryEl.querySelector<HTMLElement>(
      '.vssl-stripe--gallery--controls'
    )

    if (!slideEls.length) return

    let slideIndex = 0
    const slideCount = slideEls.length

    function setSlideIndex(index: number): void {
      // Wrap around: if index >= slideCount, go to 0; if index < 0, go to last slide
      slideIndex = index >= slideCount ? 0 : index < 0 ? slideCount - 1 : index

      // Set current slide as active
      slideEls[slideIndex].dataset.active = 'true'

      // Update counter
      if (currentCounter) {
        currentCounter.innerHTML = String(slideIndex + 1)
      }

      // Calculate next and previous slide indices
      const nextSlideIndex = slideIndex + 1 === slideCount ? 0 : slideIndex + 1
      const prevSlideIndex = slideIndex === 0 ? slideCount - 1 : slideIndex - 1

      // Preload adjacent images by removing loading attribute
      const nextImg = slideEls[nextSlideIndex].querySelector<HTMLImageElement>('img')
      const prevImg = slideEls[prevSlideIndex].querySelector<HTMLImageElement>('img')
      if (nextImg) nextImg.removeAttribute('loading')
      if (prevImg) prevImg.removeAttribute('loading')

      // Set adjacent slides as inactive (only if different from current)
      if (nextSlideIndex !== slideIndex) {
        slideEls[nextSlideIndex].dataset.active = 'false'
      }
      if (prevSlideIndex !== slideIndex) {
        slideEls[prevSlideIndex].dataset.active = 'false'
      }

      // Set inactive for all other slides
      slideEls.forEach((slide, idx) => {
        if (idx !== slideIndex && idx !== nextSlideIndex && idx !== prevSlideIndex) {
          slide.dataset.active = 'false'
        }
      })

      // Dynamically adjust controls height based on image aspect ratio
      if (controls) {
        const childImage = slideEls[slideIndex].querySelector<HTMLElement>(
          '.vssl-stripe--gallery--image'
        )
        const ratio =
          (childImage?.clientHeight || 0) / (childImage?.clientWidth || 1)

        controls.style.cssText = ratio
          ? `height: 0; padding-bottom: ${ratio * 100}%;`
          : ''
      }
    }

    // Initialize
    setSlideIndex(0)

    // Add event listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', () => setSlideIndex(slideIndex + 1))
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => setSlideIndex(slideIndex - 1))
    }
  })
}
